import React, { useEffect } from 'react';

import { Text, TextType } from 'ui-components/components/text';
import { Card } from 'ui-components/components/card';
import { ResponsiveWidth } from 'ui-components/components/responsive-layout';
import { FlexColumn } from 'ui-components/components/flex';
import { showAccountLinkingSuccessNotification } from './notifications';

import { useCurrentUser } from '../../../../../hooks/use-current-user';
import { UpdateProfileForm } from './components/update-profile-form';
import { UpdatePasswordForm } from './components/update-password-form';

import SsoAccountManagement from '../../../components/sso-account-management/sso-account-management';
import { Auth0Wrapper } from '../../../../../services/auth0/Auth0Wrapper';

import messages from '../../messages';

export const SignInSection = () => {
  const currentUser = useCurrentUser();
  const shouldRenderSsoManagement = Auth0Wrapper.isUsingAuth0Auth();

  useEffect(() => {
    const maybeLinkingResult = Auth0Wrapper.accountLinkingRequestResult;
    if (!maybeLinkingResult || !maybeLinkingResult.success) return;

    showAccountLinkingSuccessNotification(maybeLinkingResult.idpName);
  }, []);

  return (
    <FlexColumn responsiveWidth={ResponsiveWidth.Cols9}>
      <Text textType={TextType.H3} value={messages.signInSubheader} />
      <Card>
        <UpdateProfileForm />
        <UpdatePasswordForm username={currentUser.username} />
        {shouldRenderSsoManagement && <SsoAccountManagement postUnlinkHandler={(success) => success} />}
      </Card>
    </FlexColumn>
  );
};
